"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unpackBooleans(n) {
    var arr = new Array(8);
    n = Math.min(Math.max(0, Math.round(n)), 255);
    for (var z = 0; z < 8; z++) {
        var p = Math.pow(2, 7 - z);
        if (n >= p) {
            arr[z] = true;
            n -= p;
        }
        else {
            arr[z] = false;
        }
    }
    return arr;
}
exports.unpackBooleans = unpackBooleans;
function packBooleans(b) {
    var n = 0;
    for (var z = 0; z < 8; z++) {
        if (b.length > z && b[z]) {
            n += Math.pow(2, 7 - z);
        }
    }
    return n;
}
exports.packBooleans = packBooleans;
//# sourceMappingURL=vectorBoolArray.js.map